import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getChargingAuthorisationStatus } from '../../../services/charging/charging-service';
import type { IAuthoriseSessionProps } from '../../../types/propTypes';

export const useAuthoriseSessionHook = (props: IAuthoriseSessionProps) => {
    const { t } = props;
    const navigate = useNavigate();
    const { code, invoice_id } = useParams();

    useEffect(() => {
        const token = localStorage.getItem(`SESSION_TOKEN_${code}`);

        if (!token) {
            navigate('');
            return () => {};
        }

        const params = new URLSearchParams(window.location.search);

        const isPaymentRetry = params.get('paymentRetry');

        if (isPaymentRetry === 'true') {
            props.openChargingProgressPage(true);
            return () => {};
        } else {
            const checkChargingAuthorisationStatus = async () => {
                const inputData = {
                    invoice_id,
                    token,
                };
                await getChargingAuthorisationStatus(inputData)
                    .then((res) => {
                        if (res.Data && res.Data.status && res.Data.status.code === 'ACTIVE') {
                            setTimeout(() => {
                                props.openChargingProgressPage(false, false);
                            }, 2000);
                        } else if (res.Data && res.Data.status && res.Data.status.code === 'COMPLETED') {
                            props.openChargingProgressPage(false, true);
                        }
                        if (res.Data && res.Data.status && res.Data.status.code === 'INVALID') {
                            toast.error(t<string>('chargingProgress.label.unableToConnect'), {
                                autoClose: 10000,
                            });
                            navigate('/');
                        }
                    })
                    .catch((m) => {
                        if (m.response && m.response.data && m.response.data.message) {
                            toast.error(m.response.data.message);
                        } else {
                            toast.error(m.toString());
                        }
                    });
            };

            if (invoice_id) {
                checkChargingAuthorisationStatus();
                const interval = setInterval(async () => {
                    await checkChargingAuthorisationStatus();
                }, 10000);
                return () => {
                    clearInterval(interval);
                };
            } else {
                toast.error(t<string>('authoriseSession.common.error'));
                navigate('/');
                return () => {};
            }
        }
    }, []);

    return {
        t,
    };
};
